import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { BillingLine } from 'src/app/commons/models/billing-line.model';
import { PAGE_SIZE_OPTIONS } from 'src/app/helpers/table.helper';
import * as BillingLineActions from 'src/app/store/actions/billing-line.actions';
import { AppState } from 'src/app/store/reducers';
import * as BillingLineSelectors from 'src/app/store/selectors/billing-line.selectors';
import * as AuthSelectors from 'src/app/store/selectors/auth.selectors';

import { BillingLineFilters } from '../../../commons/models/billing-line.model';
import { BillingLinesColumn } from '../billing-line-list/billing-line-list.component';



@Component({
  selector: 'app-billing-line-selection',
  templateUrl: './billing-line-selection.component.html',
  styleUrls: ['./billing-line-selection.component.scss']
})
export class BillingLineSelectionComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();

  billingLines: Observable<BillingLine[]>;
  filters: Observable<BillingLineFilters>;

  @Input()
  offer_id: number;

  defaultFilters: BillingLineFilters = {
  }

  displayedColumns: BillingLinesColumn[] = ["date", "amount", "description", "actions"];

  pageSizeOptions = PAGE_SIZE_OPTIONS;

  total: Observable<number>;
  constructor(private store$: Store<AppState>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.billingLines = this.store$.pipe(select(BillingLineSelectors.getBillingLines), takeUntil(this.unsubscribe$), map(dtos => dtos ? dtos.map(dto => new BillingLine(dto)) : null));
    this.total = this.store$.pipe(select(BillingLineSelectors.getTotalBillingLines), takeUntil(this.unsubscribe$));
    this.filters = this.store$.pipe(select(BillingLineSelectors.getFilters), takeUntil(this.unsubscribe$));
    if (data) {
      this.defaultFilters = data.defaultFilters;
    }
  }

  load() {
    this.store$.dispatch(BillingLineActions.loadBillingLines(
      { page: 1, perPage: this.pageSizeOptions[0], filters: this.defaultFilters }));
  }

  sortChange(sort: Sort) {
    this.store$.dispatch(BillingLineActions.changeSort({ order: sort.active, direction: sort.direction }));
  }

  pageChange(pageEvent: PageEvent) {
    this.store$.dispatch(BillingLineActions.changePage({ page: pageEvent.pageIndex + 1, size: pageEvent.pageSize }))
  }

  filtersChange(filters: BillingLineFilters) {
    this.store$.dispatch(BillingLineActions.changeFilters({ filters }));
  }

  ngOnInit() {
    this.load();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  selectBillingLine(billingLine: BillingLine) {
    if (billingLine) {
      this.store$.dispatch(BillingLineActions.billingLineSelected({ billingLine: billingLine.toDTO() }));
    }
  }

  close() {
    this.store$.dispatch(BillingLineActions.closeSelectionDialog())
  }
}
